// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app";
import { BASE_DOCUMENT_TITLE } from "@/lib/document-title";
import { applyAccent } from "@/lib/preferences";
import "@/lib/i18n";
import "@/styles/globals.css";

// Before the first paint, so a red/blue build never flashes Focal green on load.
applyAccent();

// Authenticated pages append their own name via PageTitleProvider.
document.title = BASE_DOCUMENT_TITLE;

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
